import type { ReactNode } from "react";
import { isValidElement } from "react";
import React from "react";
import IconEdit from "../../../icons/IconEdit";
import IconShare from "../../../icons/IconShare";
import IconTrash from "../../../icons/IconTrash";
import IconClose from "../../../icons/IconClose";
import IconDocument from "../../../icons/IconDocument";
import IconCamera from "../../../icons/IconCamera";
import IconImage from "../../../icons/IconImage";
import IconScan from "../../../icons/IconScan";
import IconEye from "../../../icons/IconEye";
import type { ActionSheetIconId, InternalActionSheetOptions } from "./types";
import { getAutoIconForId } from "./actionIconMap";

export const LAYOUT = {
  HEADER_HEIGHT: 52,
  ITEM_HEIGHT: 44,
  MENU_WIDTH: 260,
  VIEWPORT_MARGIN: 16,
  BOTTOM_PADDING: 32
} as const;

export const DEFAULT_TRIGGER_POSITION = {
  x: typeof window !== "undefined" ? window.innerWidth / 2 : 0,
  y: typeof window !== "undefined" ? window.innerHeight - 100 : 0
};

const ICON_MAP: Record<ActionSheetIconId, ReactNode> = {
  edit: <IconEdit />,
  share: <IconShare />,
  delete: <IconTrash />,
  close: <IconClose />,
  document: <IconDocument />,
  scan: <IconScan />,
  image: <IconImage />,
  camera: <IconCamera />,
  view: <IconEye />
};

const isIconId = (icon: unknown): icon is ActionSheetIconId =>
  typeof icon === "string" && icon in ICON_MAP;

export const getButtonIcon = (
  button: InternalActionSheetOptions["buttons"][number]
): ReactNode | undefined => {
  if (button.icon !== undefined) {
    if (isIconId(button.icon)) {
      return ICON_MAP[button.icon];
    }
    if (isValidElement(button.icon)) {
      return button.icon;
    }
    return undefined;
  }
  return getAutoIconForId(button.id);
};
